import { Grid, GridItem } from '@thg-commerce/gravity-system'
import { spacing, styled, Text } from '@thg-commerce/gravity-theme'

export const FacilityGridItem = styled(GridItem)<{ status: boolean }>`
  ${Text('bodyText', 'default')};
  width: 100%;
  display: flex;
  align-self: start;
  gap: ${spacing(0.75)};
  color: ${(props) =>
    props.status
      ? props.theme.colors.palette.greys.darker
      : props.theme.colors.palette.accent.base};

  path {
    fill: ${(props) =>
      props.status
        ? props.theme.colors.palette.greys.darker
        : props.theme.colors.palette.accent.base};
  }
`

export const FacilityGrid = styled(Grid)`
  grid-gap: ${spacing(2)};
  -ms-grid-rows: auto;
  grid-template-rows: auto;
`
